var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useEffect } from 'react';
import Input from '.'; // 跟 InputPassword 一致的引入
var RequiredTextField = function (props) {
    var onChange = props.onChange, verify = props.verify, value = props.value, className = props.className, placeholder = props.placeholder, otherProps = __rest(props, ["onChange", "verify", "value", "className", "placeholder"]);
    var _a = useState(''), errorText = _a[0], setErrorText = _a[1];
    var inputRef = useRef(undefined);
    var inputVerify = function () {
        if (inputRef.current) {
            setErrorText(inputRef.current.validationMessage);
        }
    };
    var handleChange = function (e) {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        inputVerify();
    };
    useEffect(function () {
        if (verify) {
            inputVerify();
        }
    }, [verify]);
    return (React.createElement(Input, __assign({}, otherProps, { className: className, placeholder: placeholder, value: value, onChange: handleChange, inputRef: inputRef, required: true, error: errorText.length > 0, helperText: errorText, inputProps: __assign({}, otherProps.inputProps), FormHelperTextProps: { style: { textAlign: 'right' } } })));
};
export default RequiredTextField;
